var _defs, _path, _polygon, _polygon2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovapointRoadSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointRoad_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.53,4H15.47L4.28,28H14.5l.23-4h2.54l.23,4H27.72Zm-.76,2h.46l.23,4h-.92Zm-.35,6h1.16l.23,4H15.19Zm-.57,10,.23-4h1.84l.23,4Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.8 4 0 27.16 0 28 2.07 28 14.33 4 13.8 4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.2 4 17.55 4 29.93 28 32 28 32 27.16 18.2 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointRoadSvg);
export default __webpack_public_path__ + "static/media/NovapointRoad_svg.4f7b925abd93923c697c84c1b5c0e081.svg";
export { ForwardRef as ReactComponent };